import AssignmentPage from './AssignmentPage/AssignmentPage.container';

export default AssignmentPage;
